import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement, ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, fontSize, radius, shadow, space, zIndex } from "../tokens.stylex.ts";
export function TooltipProvider({
  children
}: {
  children: ReactNode;
}) {
  return <BaseTooltip.Provider delay={400}>{children}</BaseTooltip.Provider>;
}

/** Supplementary hint only — never put essential information in a tooltip. */
export function Tooltip({
  content,
  children
}: {
  content: ReactNode;
  children: ReactElement;
}) {
  return <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner sideOffset={6} className="x362c0v">
          <BaseTooltip.Popup className="x4x6xz0 x1uu5im9 xoazux2 x1pl96vq xv1gbk9 x14f1h33 xmccgnw x14lruf5">{content}</BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>;
}